<template>
  <component :is="iconComponent" />
</template>

<script lang="ts" setup>
import { computed, PropType } from 'vue';
import { Icons, IconType } from '@/shared/icons/icons';

const props = defineProps({
  icon: {
    type: String as PropType<IconType>,
    required: true,
  },
});

const iconComponent = computed(() => Icons[props.icon]);
</script>
